import { BackgroundMode, FlowType, ProgressBarSettings } from '@ply-io/ply-front-shared-utilities';

export const ALL_FEATURE_TYPES = 'everything';

export const WORKFLOW_ERROR_CODES = {
	MODULE_NOT_FOUND_ERROR_CODE: 'workflow-0001',
	MOVE_WORKFLOW_FAILED: 'workflow-0041',
	PUBLISH_MISSING_DEPENDENCY_NODES: 'workflow-0047',
	TEST_MISSING_DEPENDENCY_NODES: 'workflow-0048',
	RUNNING_DISABLED_FLOW: 'workflow-0049',
	MISSING_PORTAL_AUTH: 'workflow-0065',
};

export const SHAREABLE_FLOW_TYPES = [FlowType.Experience, FlowType.Tool];

export const BACKGROUND_MODES = [
	{
		text: 'Off',
		value: BackgroundMode.Off,
	},
	{
		text: 'Image',
		value: BackgroundMode.Image,
	},
	{
		text: 'Color',
		value: BackgroundMode.BackgroundColor,
	},
];
export const BACKGROUND_IMAGES = [
	'feature-background-1',
	'feature-background-2',
	'feature-background-3',
	'feature-background-4',
	'feature-background-5',
	'feature-background-6',
];

export const PROGRESS_BAR_OPTIONS = [
	{
		text: 'Simple loader',
		value: ProgressBarSettings.Simple,
	},
	{
		text: 'Progress bar',
		value: ProgressBarSettings.Regular,
	},
	{
		text: 'Progress bar with status',
		value: ProgressBarSettings.Debugger,
	},
];

export const FEATURE_BACKGROUND_IMAGE_SUPPORTED_TYPES = ['.png', '.jpg', '.jpeg'];

const SUB_FLOW_SAMPLE = 'sub_flow_sample';
const AUTOMATION_SAMPLE = 'automation_sample';
export const WAITING_FLAG_TYPES = {
	SUB_FLOW_SAMPLE,
	AUTOMATION_SAMPLE,
};
